import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { AuthStore } from '@easihub/ngx';

export const appRoutes: Route[] = [
  {
    path: '',
    canMatch: [
      (() => {
        let ready;
        return () => {
          ready ||= inject(AuthStore).ready;
          return ready;
        };
      })()
    ],
    children: [
      {
        path: 'sign-out',
        loadComponent: () => import('@easihub/ngx/navigation/signing-out/signing-out.page'),
        data: {
          layout: 'minimal'
        }
      },
      {
        path: 'impact-dashboard',
        pathMatch: 'full',
        loadComponent: () => import('../impact-dashboard/impact-dashboard.page'),
        data: {
          seo: {
            title: 'Impact Dashboard'
          }
        }
      },
      {
        path: '',
        loadChildren: () => import('../public/routes')
      }
    ]
  }
  // ...ACCOUNT_ROUTES,
  // {
  //   path: 'jobs',
  //   loadChildren: () => import('../jobs/routes')
  // },
  // {
  //   path: '',
  //   pathMatch: 'full',
  //   loadComponent: () => import('../public/home/home.page'),
  //   data: {
  //     seo: {
  //       title: 'Home',
  //       description: 'Welcome to the EasiHub platform',
  //     },
  //   },
  // },
  // {
  //   path: 'about-us',
  //   pathMatch: 'full',
  //   loadComponent: () => import('../public/about-us/about-us.page'),
  //   data: {
  //     seo: {
  //       title: 'About Us'
  //     }
  //   }
  // },
  // {
  //   path: 'contact-us',
  //   pathMatch: 'full',
  //   loadComponent: () => import('../public/contact-us/contact-us.page'),
  //   data: {
  //     seo: {
  //       title: 'Contact Us'
  //     }
  //   }
  // },
  // {
  //   path: 'community',
  //   children: [
  //     {
  //       path: 'guidelines',
  //       loadComponent: () => import('../public/community/guidelines/guidelines.component')
  //         .then(c => c.GuidelinesComponent),
  //       data: {
  //         meta: {
  //           title: 'Community Guidelines - EasiHub',
  //           description: 'Our community standards and expectations',
  //           canonical: 'https://easihub.com/community/guidelines'
  //         }
  //       }
  //     },
  //     {
  //       path: 'code-of-conduct',
  //       loadComponent: () => import('../public/community/code-of-conduct/code-of-conduct.component')
  //         .then(c => c.CodeOfConductComponent),
  //       data: {
  //         meta: {
  //           title: 'Code of Conduct - EasiHub',
  //           description: 'Our commitment to a respectful community environment',
  //           canonical: 'https://easihub.com/community/code-of-conduct'
  //         }
  //       }
  //     },
  //     {
  //       path: 'getting-started',
  //       loadComponent: () => import('../public/community/start-exploring/start-exploring.component')
  //         .then(c => c.StartExploringComponent),
  //       data: {
  //         meta: {
  //           title: 'Getting Started - EasiHub Community',
  //           description: 'Begin your journey in the EasiHub enterprise application community',
  //           canonical: 'https://easihub.com/community/start-exploring'
  //         }
  //       }
  //     },
  //     {
  //       path: 'join-moderator',
  //       loadComponent: () => import('../public/community/join-moderator/join-moderator.component')
  //         .then(c => c.JoinModeratorComponent),
  //       data: {
  //         meta: {
  //           title: 'Join as Moderator - EasiHub',
  //           description: 'Help build and maintain our community standards',
  //           canonical: 'https://easihub.com/community/join-moderator'
  //         }
  //       }
  //     },
  //     {
  //       path: 'posting-guidelines',
  //       loadComponent: () => import('../public/community/posting-guidelines/posting-guidelines.component')
  //         .then(c => c.PostingGuidelinesComponent),
  //       data: {
  //         meta: {
  //           title: 'Posting Guidelines - EasiHub',
  //           description: 'How to create effective posts in our community',
  //           canonical: 'https://easihub.com/community/posting-guidelines'
  //         }
  //       }
  //     },
  //     {
  //       path: '',
  //       redirectTo: 'guidelines',
  //       pathMatch: 'full'
  //     }
  //   ]
  // },
  // {
  //   path: 'legal',
  //   loadChildren: () => import('../public/legal/legal.routes')
  //     .then(m => m.legalRoutes)
  // },
  // {
  //   path: 'assessment',
  //   children: [
  //     {
  //       path: 'error-intelligence',
  //       loadComponent: () => import('../public/assessment/error-intelligence/error-intelligence.page'),
  //       data: { seo: { title: 'Error Intelligence', description: 'Instantly decode and resolve enterprise software errors from SAP, Oracle, Salesforce, and more.' } }
  //     },
  //     {
  //       path: 'error-intelligence/:code',
  //       loadComponent: () => import('../public/assessment/error-intelligence/error-intelligence-detail.page'),
  //       data: { seo: { title: 'Error Detail — Error Intelligence' } }
  //     },
  //     {
  //       path: 'integration-risk-analyzer',
  //       loadComponent: () => import('../public/assessment/integration-risk-analyzer/integration-risk-analyzer.page'),
  //       data: { seo: { title: 'Integration Risk Analyzer', description: 'Analyze integration risk and compatibility between enterprise systems.' } }
  //     },
  //     {
  //       path: 'integration-risk-analyzer/results',
  //       loadComponent: () => import('../public/assessment/integration-risk-analyzer/integration-risk-results.page'),
  //       data: { seo: { title: 'Integration Analysis Results — Integration Risk Analyzer' } }
  //     },
  //     {
  //       path: 'delivery-readiness-score',
  //       loadComponent: () => import('../public/assessment/delivery-readiness-score/delivery-risk.page'),
  //       data: { seo: { title: 'Delivery Readiness Score', description: 'Score your enterprise implementation readiness across 7 risk dimensions.' } }
  //     },
  //     {
  //       path: 'delivery-risk-score/results',
  //       loadComponent: () => import('../public/assessment/delivery-readiness-score/delivery-risk-results.page'),
  //       data: { seo: { title: 'Readiness Score Results — Delivery Readiness Score' } }
  //     },
  //     {
  //       path: 'solution-fit-selector',
  //       loadComponent: () => import('../public/assessment/solution-fit-selector/solution-fit-selector.page'),
  //       data: { seo: { title: 'Solution Fit Selector', description: 'Find the best-fit enterprise software modules for your business process.' } }
  //     },
  //     {
  //       path: 'solution-fit-selector/results',
  //       loadComponent: () => import('../public/assessment/solution-fit-selector/solution-fit-results.page'),
  //       data: { seo: { title: 'Solution Fit Results — Solution Fit Selector' } }
  //     },
  //     {
  //       path: '',
  //       redirectTo: 'error-intelligence',
  //       pathMatch: 'full'
  //     }
  //   ]
  // },
  // {
  //   path: '**',
  //   component: NotFoundPageComponent,
  // }
];
